import { BILLING_NOTE_GENERATION_STATUS } from "~/providers/constants/billingNoteGenerationStatus";
import { PatientBillingNote } from "~/providers/utils/types/patientBillingNoteTypes";

export const isBillingNoteGenerationPending = (
  billingNote: PatientBillingNote,
) => {
  if (billingNote.completed_at) {
    return false;
  }

  return (
    billingNote.ai_generation_status ===
      BILLING_NOTE_GENERATION_STATUS.pending ||
    billingNote.ai_generation_status ===
      BILLING_NOTE_GENERATION_STATUS.in_progress
  );
};

export const isBillingNoteGenerationFailed = (
  billingNote: PatientBillingNote,
) => billingNote.ai_generation_status === BILLING_NOTE_GENERATION_STATUS.failed;
